{
  "version" : 1,
  "api": {
    "us": null,
    "eu": null
  }
}
